export const INITIALIZE_BUSINESS_PROFILE_CONNECT = 'initialize-business-profile-connect';
const initializeBusinessProfileConnect = () => ({
  type: INITIALIZE_BUSINESS_PROFILE_CONNECT,
});
export default initializeBusinessProfileConnect;
